import { observer } from "mobx-react-lite";
import { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  ConfigProvider,
  Empty,
  Form,
  Modal,
  Row,
  Table,
  Typography,
} from "antd";
import { MyApplicationStore } from "../../../../store";
import Column from "antd/es/table/Column";

function ApplicationDetails(props: any) {
  const { Paragraph, Text } = Typography;
  const form = Form.useFormInstance();
  const [ellipsis, setEllipsis] = useState(true);
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <Modal
        width={"60%"}
        centered
        loading={MyApplicationStore.ApplicationtableLoad}
        title={"申请详情"}
        open={MyApplicationStore.applicationModal.isOpen}
        destroyOnClose={true}
        onCancel={() => MyApplicationStore.applicationModal.close()}
        footer={null}
      >
        <Form
          form={form}
          labelWrap
          style={{ marginTop: "10px" }}
        >
        <Row justify="start">
          <Col span={11} offset={1}>
            <Form.Item  label="申请编号：">
              {MyApplicationStore.applyDetail.applicationNo}
            </Form.Item>
          </Col>
          {MyApplicationStore.applicationModal.apply && (
            <Col span={11} offset={1}>
              <Form.Item  label="申请名称：">
                {MyApplicationStore.applyDetail.name}
              </Form.Item>
            </Col>
          )}
          <Col span={11} offset={1}>
            <Form.Item  label="号池名称：">
              {
                MyApplicationStore.getAllXPoolWriteInfo.find(
                  (item: any) =>
                    item.no == MyApplicationStore.applyDetail.portalXpoolNo
                )?.name
              }
            </Form.Item>
          </Col>
          {MyApplicationStore.applicationModal.add && (
            <Col span={11} offset={1}>
              <Form.Item label="号码文件：">
                <Button
                  type="link"
                  onClick={() =>
                    MyApplicationStore.exportNumber(
                      MyApplicationStore.applyDetail.applicationNo
                    )
                  }
                >
                  号码文件
                </Button>
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.applicationModal.add && (
            <Col span={11} offset={1}>
              <Form.Item label="附件：">
                <Button
                  type="link"
                  onClick={() =>
                    MyApplicationStore.getPreSignedUrl(
                      MyApplicationStore.applyDetail
                        .numberReportingPdfObjectName,
                      "号码报备书"
                    )
                  }
                >
                  号码报备书
                </Button>
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.detailData.status == "RETURNED" && (
            <Col span={11} offset={1}>
              <Form.Item label="退回原因：">
                {MyApplicationStore.applyDetail.message}
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.applicationModal.apply && (
            <Col span={11} offset={1}>
              <Form.Item label="虚拟运营商：">
                {MyApplicationStore.applyDetail.vnoId}
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.applicationModal.apply && (
            <Col span={11} offset={1}>
              <Form.Item label="预计周投诉个数：">
                {MyApplicationStore.applyDetail.complaintLimit}
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.applicationModal.apply && (
            <Col span={11} offset={1}>
              <Form.Item label="预计投比(1/W分钟)：">
                {MyApplicationStore.applyDetail.expectedRatio}
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.applicationModal.apply && (
            <Col span={11} offset={1}>
              <Form.Item  label="话术场景：">
                {MyApplicationStore.applyDetail.speechScene}
              </Form.Item>
            </Col>
          )}
          {MyApplicationStore.applicationModal.apply && (
            <Col span={11} offset={1}>
              <Form.Item style={{width:'100%'}} label="话术范围：">
                <Text
                  style={ellipsis ? { width: '90%' } : undefined}
                  ellipsis={
                    ellipsis
                      ? { tooltip: MyApplicationStore.applyDetail.speechRange }
                      : false
                  }
                >
                  {MyApplicationStore.applyDetail.speechRange}
                </Text>
              </Form.Item>
            </Col>
          )}
        </Row></Form>
        <ConfigProvider renderEmpty={tableEmptyRender}>
          <Table
            dataSource={
              MyApplicationStore.applicationModal.add
                ? MyApplicationStore.applyDetail?.xpoolNumberDetailRespPageable
                    ?.content
                : MyApplicationStore.applyDetail.xpoolApplicationDetails
            }
            rowKey={(record: any) =>
              MyApplicationStore.applicationModal.apply
                ? record.order
                : record.phoneNumber
            }
            scroll={{
              x: MyApplicationStore.applicationModal.add ? 1400 : 800,
              y: "calc(100vh - 500px)",
            }}
            className="tableSty"
            style={{ margin: "0 10px",marginBottom:'20px' }}
            pagination={
              MyApplicationStore.applicationModal.add
                ? {
                    current: MyApplicationStore.ApplicationpageDataModal.page,
                    pageSize: MyApplicationStore.ApplicationpageDataModal.size,
                    onChange:
                      MyApplicationStore.ApplicationpageDataModal.changePage,
                    pageSizeOptions: [10, 15, 20, 25],
                    showSizeChanger: true,
                    total:
                      MyApplicationStore.applyDetail
                        ?.xpoolNumberDetailRespPageable?.totalElements,
                    showTotal: () =>
                      `共计${MyApplicationStore.applyDetail?.xpoolNumberDetailRespPageable?.totalElements}条`,
                    position: ["bottomLeft"],
                  }
                : false
            }
            size="small"
          >
            {MyApplicationStore.applicationModal.add && (
              <Column ellipsis={true} title="号码" dataIndex="phoneNumber" />
            )}
            {MyApplicationStore.applicationModal.add && (
              <Column
                ellipsis={true}
                title="所属X池编号"
                dataIndex="portalXpoolNo"
              />
            )}
            {MyApplicationStore.applicationModal.add && (
              <Column ellipsis={true} title="备注" dataIndex="remark" />
            )}
            {MyApplicationStore.applicationModal.add && (
              <Column
                ellipsis={true}
                title="平台编号"
                dataIndex="targetPlatformCode"
              />
            )}
            {MyApplicationStore.applicationModal.apply && (
              <Column ellipsis={true} title="序号" dataIndex="order" />
            )}
            {MyApplicationStore.applicationModal.add && (
              <Column
                ellipsis={true}
                title="虚拟运营商ID"
                dataIndex="virtualCarrierId"
              />
            )}
            {MyApplicationStore.applicationModal.add && (
              <Column
                ellipsis={true}
                title="基础运营商"
                dataIndex="infraCarrier"
              />
            )}
            {MyApplicationStore.applicationModal.add && (
              <Column
                ellipsis={true}
                title="号码所属区号"
                dataIndex="areaCode"
              />
            )}
            <Column ellipsis={true} title="省" dataIndex="provinceName" />
            <Column ellipsis={true} title="市" dataIndex="cityName" />
            {MyApplicationStore.applicationModal.apply && (
              <Column ellipsis={true} title="数量" dataIndex="quantity" />
            )}
          </Table>
        </ConfigProvider>
      </Modal>
    </Fragment>
  );
}

export default observer(ApplicationDetails);
